import { render, staticRenderFns } from "./zhibo.vue?vue&type=template&id=ceadbed0&"
import script from "./zhibo.vue?vue&type=script&lang=js&"
export * from "./zhibo.vue?vue&type=script&lang=js&"
import style0 from "./zhibo.vue?vue&type=style&index=0&id=ceadbed0&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports